import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { UserCentricsService } from '@warema/shared/consent';
import { WaremaButton } from '@warema/warema-ui-angular';
import { noop } from 'rxjs';
import { ConsentInfo } from '../../models/ConsentInfo';

@Component({
    selector: 'warema-consent',
    templateUrl: './consent.component.html',
    styleUrls: ['./consent.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, WaremaButton],
})
export class ConsentComponent implements OnInit {
    private readonly _route = inject(ActivatedRoute);
    private readonly _router = inject(Router);
    private readonly _location = inject(Location);
    private readonly _userCentricsService = inject(UserCentricsService);

    private _consentName: string;
    public consentInfo: ConsentInfo = new ConsentInfo();

    public ngOnInit(): void {
        this._consentName = this._route.snapshot.queryParams['consentName'] as string;
        this.consentInfo = ConsentInfo.createFor(this._consentName);

        void this._userCentricsService
            .hasUserCurrentlyConsented(this._consentName)
            .then(consented => (consented ? this._continue() : noop()))
            .catch();
    }

    public async acceptConsent(): Promise<void> {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        await this._userCentricsService.acceptConsent(this._consentName!);
        this._continue();
    }

    public goBack(): void {
        if (!document.referrer) {
            void this._router.navigateByUrl('/');
            return;
        }
        this._location.back();
    }

    private _continue(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        void this._router.navigateByUrl(this._userCentricsService.redirectUrl || this.consentInfo.url);
    }
}
